/** Preset reference photos for on-model generation */
export const CATALOG_HOODIE_REFERENCE = {
  id: 'catalog-hoodie-man',
  label: 'Catalog look',
  description: 'Man in a white hoodie, hands in pockets, concrete backdrop',
  url: '/reference-photos/catalog-hoodie-man.png',
  modelGender: 'man',
  garmentHint: 'plain white pullover hoodie',
  promptHint:
    'Match a catalog menswear reference: adult man, front-facing three-quarter pose, hands in pockets, plain light grey concrete wall background, soft natural daylight, waist-up to full-body framing similar to a standard ecommerce on-model photo. Model wears the designed garment as the hero piece.'
}

export const REFERENCE_PHOTO_PRESETS = [CATALOG_HOODIE_REFERENCE]

/** Ids saved in older drafts and designs */
const LEGACY_REFERENCE_IDS = { 'evans-group-hoodie': CATALOG_HOODIE_REFERENCE.id }

export function normalizeReferencePhotoId(id) {
  return LEGACY_REFERENCE_IDS[id] || id
}

export function getReferencePreset(id) {
  const key = normalizeReferencePhotoId(id)
  return REFERENCE_PHOTO_PRESETS.find((p) => p.id === key) || null
}

export function referencePhotoSpec(referencePhotoId, useReferencePhoto) {
  if (!useReferencePhoto || !referencePhotoId) {
    return { useReferencePhoto: false }
  }
  const preset = getReferencePreset(referencePhotoId)
  if (!preset) return { useReferencePhoto: false }
  return {
    useReferencePhoto: true,
    referencePhotoId: preset.id,
    referencePhotoUrl: preset.url,
    referencePhotoLabel: preset.label,
    referencePhotoPromptHint: preset.promptHint
  }
}

export function appendReferencePhotoToPrompt(prompt, specifications) {
  if (!specifications?.useReferencePhoto) return prompt
  const hint =
    specifications.referencePhotoPromptHint ||
    getReferencePreset(specifications.referencePhotoId)?.promptHint
  if (!hint) return prompt
  return `${prompt} REFERENCE SHOT GUIDANCE: ${hint}`
}
